import { DependenciesInjection } from "app/di/DependencyInjection";
import { CapabilityImpl } from "../data/CapabilityImpl";
import { ICapabilityRepository } from "../domain/repositories/ICapabilityRepository";
import { CapabilityUseCase } from "../domain/useCases/CapabilityUseCase";
import { CapabilityViewModel } from "../presentation/viewModel/CapabilityViewModel";
import { CapabilityToken } from "./CapabilityToken";

export class CapabilityInjection {
  static initInjections() {
    DependenciesInjection.register<ICapabilityRepository>(
      CapabilityToken.ICapabilityRepository,
      CapabilityImpl,
      "otherRepo",
    );
    DependenciesInjection.register<CapabilityUseCase>(
      CapabilityToken.CapabilityUseCase,
      CapabilityUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<CapabilityViewModel>(
      CapabilityToken.CapabilityViewModel,
      CapabilityViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<ICapabilityRepository>(
      CapabilityToken.ICapabilityRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<CapabilityUseCase>(
      CapabilityToken.CapabilityUseCase,
    );
  }
}
